import { Component } from "preact";
import { connect } from "react-redux";
import Content from "../../components/Content";
import Page from "../../components/Page";
import Picture from "../../components/Picture";
import { getOrder } from "../../state/actions/orderActions";
import { getGiftCardPage } from "../../state/actions/giftCardActions";
import WhatToDoNext from "../../components/WhatToDoNext";
import { css } from "emotion";
//import Button from "../../components/Button"
const wrapper = css({
  maxWidth: 800,
  width: "100%",
  backgroundColor: "#FFF",
  margin: "0 auto",
  borderRadius: 4,
  padding: "32px 12px",
  textAlign: "center",
  boxShadow: "0 1px 10px 0 rgba(9, 30, 66, 0.13)",
  marginBottom: 14,
  "@media(max-width: 800px)": {
    padding: "24px 12px"
  }
});
const heading = css({
  marginBottom: 8
});
const paragraph = css({
  marginBottom: 24
});
const charityText = css({
  fontSize: 16,
  width: 400
});
class GlobalOrderComplete extends Component {
  componentDidMount() {
    const {
      order,
      orderId,
      getOrder,
      giftCards,
      slug,
      getGiftCardPage
    } = this.props;
    if (!order.data && !order.loading) {
      getOrder(orderId);
    }
    if (!giftCards.giftCardPage && !giftCards.loading) {
      getGiftCardPage(slug);
    }
  }
  render({ order, giftCards }) {
    if (!order.data || giftCards.loading) {
      return;
    }
    return (
      <div
        style={{
          backgroundColor: "#F7FBFF"
        }}
      >
        <Page transparent={true} border={false} isGlobal={true}>
          <Content>
            <div
              style={{
                paddingTop: 40,
                paddingLeft: 14,
                paddingRight: 14
              }}
            >
              <div class={wrapper}>
                <Thanks order={order} giftCards={giftCards} />
                <OrderDetails order={order} />
                <WhatToDoNext />
              </div>
            </div>
          </Content>
        </Page>
      </div>
    );
  }
}

const orderBox = css({
  padding: "12px 16px",
  borderRadius: 4,
  border: "solid 1px #dedede",
  maxWidth: 800,
  width: "100%",
  textAlign: "left"
});
const OrderDetails = ({ order }) => {
  const purchaseList = order.data.giftCards.reduce((list, giftCard) => {
    const index = list.indexOf(
      giftCardQuant => giftCardQuant._id === giftCard._id
    );
    if (index >= 0) {
      list[index].quantity++;
    } else {
      list.push({
        _id: giftCard._id,
        name: giftCard.giftCardTypeName,
        quantity: 1
      });
    }
    return list;
  }, []);
  const purchaseString = purchaseList.reduce((str, item, i) => {
    const last = i === purchaseList.length - 1;
    return `${str}${item.quantity} x ${item.name} ${last ? "" : ","}`;
  }, "");
  return (
    <div className={orderBox}>
      <h2>Your order details</h2>
      <p>{`You have purchased: ${purchaseString}`}</p>
      <p>{`Order name: ${order.data.orderName}`}</p>
      <p>{`Order date: ${order.data.completedDisplayDate}`}</p>
    </div>
  );
};

const Thanks = ({ order, giftCards }) => {
  const { giftCardPage } = giftCards;
  const { style } = giftCardPage;
  return (
    <div>
      <h1 className={heading}>
        Thanks for your purchase, {order.data.firstName}!
      </h1>
      <EmailDetails order={order} />
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Picture
          img={style.banner}
          alt={`${giftCardPage.name} Event Banner`}
          width={400}
        />
      </div>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <p className={charityText}>
          Humanitix donates 100% of booking fee profits to programs that
           empower disadvantaged students through education.
        </p>
      </div>
    </div>
  );
};

const EmailDetails = ({ order }) => {
  const { giftCards } = order.data;
  const emails = Array.from(
    new Set(
      giftCards.map(giftCard => {
        return giftCard.recipientEmail;
      })
    )
  );
  const isPlural = giftCards.length > 1;
  const emailString = emails.reduce((str, email, i) => {
    return `${str}${email}${i === emails.length - 1 ? "" : ", "}`;
  }, "");
  return (
    <p className={paragraph}>
      {`Your gift card${
        isPlural ? "s have" : " has"
      } successfully been sent to ${emailString}`}
    </p>
  );
};
export default connect(
  state => ({
    order: state.order,
    giftCards: state.giftCards
  }),
  { getOrder, getGiftCardPage }
)(GlobalOrderComplete);



// WEBPACK FOOTER //
// ./routes/complete/GlobalOrderComplete.js